import React, {useState} from "react";
import { Container, Row, Col} from "react-bootstrap";
import "./PropertyBanner.scss";
import ImageModule from "../../modules/image_module";

import SearchResultsImagePopup from "../SalesCard/SearchResultsImagePopup"

const Banner = ({property_data}) => {

    const [photoIndex, setPhotoIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const openLighboxMobile = (e, ind) => {
        e.preventDefault();
        setPhotoIndex(ind);
        setIsOpen(true);
    } 

    const ImageRenderList = ({item, image_url, imagename}) => {
        let processedImages = JSON.stringify({});
        if (item?.imagetransforms?.images_Transforms) {
            processedImages = item?.imagetransforms?.images_Transforms;
        }
        return (
          <ImageModule ImageSrc={image_url} title={item.display_address} altText={item.display_address} imagetransforms={processedImages} renderer="srcSet" imagename={imagename} strapi_id={item.id} />                           
        )
    }

    var images_filter = property_data?.images?.length > 0 && property_data?.images?.filter(img => img?.url && img.url !== null)

    return (
        <React.Fragment>
            <section className="property-banner">
                <Container>
                    <Row>
                        <Col>
                            <div className="banner-wrap">
                                <div className={`banner-img ${images_filter?.length <= 1 ? "full_wdth" : ""}`}>
                                    <span className="banner_arw left_arw" onClick={(e) => openLighboxMobile(e,(images_filter.length - 1))}>
                                        <span className="icon-dropdown"></span>
                                    </span>

                                    <span className="banner_arw right_arw" onClick={(e) => openLighboxMobile(e,0)}>
                                        <span className="icon-dropdown"></span>
                                    </span>

                                    {/* <span className="transp_bg" onClick={(e) => openLighboxMobile(e,0)}></span> */}

                                    <span onClick={(e) => openLighboxMobile(e,0)}>
                                        {/* <img src={BannerImg} alt="banner-img" /> */}
                                        <ImageRenderList item={property_data} image_url={images_filter[0]} imagename={"property.images.details_large"}  />
                                    </span>
                                    
                                    {property_data?.extra?.officeDepartment === "Prestige" ?
                                        <span className="top-text prestige_bg">Hardisty <span className="prestige_clr">Prestige</span></span>
                                    :
                                        property_data?.extra?.officeDepartment === "Collection" ?
                                        (
                                            process.env.GATSBY_SITE_NAME === "John Shepherd" ?
                                                <span className="top-text collection_bg">John Shepherd <span className="collection_clr">Collection</span></span> 
                                            : 
                                                <span className="top-text collection_bg"><span className="collection_clr">Collection</span></span> 
                                        )
                                    : ''
                                    }                  
                                    {(property_data?.status !== "For Sale" && property_data?.status !== "To Let") ? <span className={`top-text ${property_data?.extra?.officeDepartment}`}>{property_data.status} </span> : ''
                                    }

                                    {images_filter.length > 0 && 
                                    <a href="javascript:;" className="bottom-text" onClick={(e) => openLighboxMobile(e,0)}>
                                        <i className="gallery-icon"></i>
                                        {images_filter.length > 1 ?
                                            <span className="text">1/{images_filter.length}</span>
                                            :
                                            <span className="text">{images_filter.length}</span>
                                        }
                                    </a>
                                    }
                                </div>

                                {images_filter?.length > 1 && 
                                    <div className="sm-property-banner d-none d-lg-block">
                                        {images_filter?.map((item, index) => {
                                            if(index >= 1 && index < 3){
                                                return(
                                                    <span onClick={(e) => openLighboxMobile(e,index)}>
                                                        <ImageRenderList item={property_data} image_url={images_filter[index]} imagename={"property.images.details_thumbnail"} />
                                                    </span>
                                                )
                                            }                                            
                                        })}
                                    </div>
                                }
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {isOpen && (images_filter && images_filter?.length != 0) && (
                <SearchResultsImagePopup
                    propertyId = {property_data.id}
                    propertyImage = {images_filter}
                    photoIndex={photoIndex}
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    img_type = {"property_details"}
                    property_data={property_data}
                />
            )}
        </React.Fragment>
    );
};
export default Banner;
